import { intercept, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Link, Prompt, withRouter } from 'react-router-dom';
import { Button, Col, Input, Row } from 'reactstrap';
import FormGroup from 'reactstrap/lib/FormGroup';
import Label from 'reactstrap/lib/Label';
import DataTable from 'src/Components/DataTable';
import EInput, { EButton } from 'src/Components/EInput';
import WellFooter from 'src/Components/Footer/WellFooter';
import { IDispatchTicketList } from 'src/Interfaces/DispatchInterface';
import {DispatchStore} from 'src/Stores/Dispatch/DispatchStore';
import { MessageStore } from 'src/Stores/Messages/Messages';
import { WellsStore } from 'src/Stores/Wells/WellsStore';
import { IAttachedFile ,IWell } from '../../../../Interfaces/WellInterface';
import ButtonRow from '../../../ButtonRow';
import WorkflowHeader from '../../WorkflowHeader';
import WellCloseButton from '../WellCloseButton';
import WellRevertCloseButton from "../WellRevertCloseButton";
// import  Dropdown  from './Dropdown';

interface IParams {
    wellId: string;
}

@inject('stores')
@observer
class WellFiles extends React.Component {
    public props: any;
    public params: IParams;
    private DispatchStore: DispatchStore;
    private WellsStore: WellsStore;
    private MessageStore: MessageStore;
    private fileCategory: IAttachedFile = new IAttachedFile();
    public attachedFile: IAttachedFile[] = [];
    public dispatchTickets: IDispatchTicketList[] = [];
    // disposers
    public wellDisposer: any;
  

    public state = {
        attachedFile: this.attachedFile,
        dispatchTickets: this.dispatchTickets,
        fileCategory: this.fileCategory,
        isDirty: false,
        selectedCategory: '',
        selectedFile: [] as any[],
        submitDisabled: true,
        well: new IWell(),
        wellId: this.props.match.params.wellId
    };

    constructor(props: any) {
        super(props);

        this.WellsStore = this.props.stores.WellsStore;
        this.DispatchStore = this.props.stores.DispatchStore;
        this.MessageStore = props.stores.MessageStore;
        this.params = this.props.match.params;
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    public componentDidMount() {
        this.createDisposers();
        if (this.props.stores.WellsStore.well) {
            this.setState({
                well: this.props.stores.WellsStore.well,
            });
        } else {
            this.WellsStore.getWellDetails(this.params.wellId);
        }
    }

    public componentWillUnmount() {
        this.wellDisposer();
    }

    public createDisposers() {
        this.wellDisposer = intercept(this.WellsStore, 'well', (change: any) => {
            this.setState({
                well: toJS(change.newValue),
            });

            return change;
        });
    }

    private updateWellModel = () => {
        this.WellsStore.updateWellModel(this.state.well)
            .then(
                (data: any) => {
                    if (data) {
                        this.setState({
                            isDirty: false,
                        });
                    }
                }
            );
    }

    public onFileChange = (event: any) => {
        // Update the state 
        this.setState({
            isDirty: true,
            selectedFile: event.target.files,
        });

    }

    public onFileUpload = () => {
        if (!this.state.selectedFile) {
            return;
        }

        const formData = new FormData();
        for (const file of this.state.selectedFile) {
            formData.append(`File`, file);
        }
        // Request made to the backend api 
        this.WellsStore.postWellFile(this.state.well.id, formData)
            .then(data => {
                if (data) {
                    this.MessageStore.addMessage('File Upload Successful', 'success');
                    this.WellsStore.getWellDetails(this.state.well.id);
                    this.setState({
                        isDirty: false,
                        selectedFile: [],
                    });
                    const fileInput = document.getElementById("file") as any;
                    if (fileInput) {
                        fileInput.value = '';
                    }
                }
            });

    }

    public renderDownload = (file: any) => () => {
        if (file.name.includes('.pdf')) {
            return <React.Fragment>
                <Button
                    color="primary"
                    onClick={this.handleDownload(file)}
                >Download</Button>
                <Button
                    color="primary"
                    onClick={this.handleOpenNewWindow(file)}
                >Open in New Tab</Button>
            </React.Fragment>;
        }
        return <Button
            color="primary"
            onClick={this.handleDownload(file)}
        >Download</Button>;
    }

    public renderDispatchTicketDownload = (ticket: IDispatchTicketList, index: any) => () => {
            return <React.Fragment>
                <Button
                    color="primary"
                    onClick={this.handleDownloadDispatchTicket(ticket)}
                >Download</Button>
                {
                <Link
                className="btn btn-primary" 
                target="_blank"
                    to={ticket.type === "Delivery" ? `/print/dispatchtruckticket/${ticket.id}/delivery` : `/print/dispatchtruckticket/${ticket.id}/pickup`}
                    // onClick={this.handleOpenNewWindow(ticket)}
                >Open in New Tab</Link>
    }
            </React.Fragment>;
      
    }


    public renderSize = (size: string) => () => {
        const sizeNum = Number(size);
        if (sizeNum > 1000000) {
            return `${(sizeNum / 1000000).toFixed(2)} MB`;
        } else if (sizeNum > 1000) {
            return `${(sizeNum / 1000).toFixed(2)} KB`;
        } else {
            return `${sizeNum} B`;
        }
    }
    private handleDownload = (file: any) => () => {
        return this.WellsStore.getWellFile(file.id, file.name);
    }

    private handleDownloadDispatchTicket = (ticket: IDispatchTicketList) => () => {
        return this.DispatchStore.getDispatchTicketForDownload(ticket);
    }


    private handleOpenNewWindow = (file: any) => () => {
        return this.WellsStore.openWellFileInNewTab(file.id, file.name);
    }

    private handleDeleteFile = (index: number) => {
        const fileToDelete = this.state.well.files[index];
        this.WellsStore.deleteWellFile(fileToDelete.id)
            .then(data => {
                if (data) {
                    this.MessageStore.addMessage('File Deleted', 'success');
                    this.WellsStore.getWellDetails(this.state.well.id);
                }
            });
    }

    private handleInputChange = (index: number) => (event: any) => {
        const well = this.state.well;
        well.files[index].fileCategory = event.target.value;
        const filesMissingCategory = well.files.some(file => !file.fileCategory);
          this.setState({
          isDirty: true,
          submitDisabled: filesMissingCategory,
          well
          });
      }

    public renderDropdown = (category: string, index: number) => () => {
        return (
            <FormGroup>
                <EInput
                    type="select"
                    name="Category"
                    value={this.state.well.files[index].fileCategory}
                    onChange={this.handleInputChange(index)}
                >
                    <option value=" " />
                    <option value="Not Categorized">Not Categorized</option>
                    <option value="Signed Documents">Signed Documents</option>
                    <option value="Unsigned Documents">Unsigned Documents</option>
                    <option value="3rd Party Documents">3rd Party Documents</option>
                    <option value="General Well Info">General Well Info</option>
                </EInput>
            </FormGroup>
        );
    }

    private formatWellFiles = () => {
        const files = this.state.well.files;
        const headers = [
            "File Name",
            "Category",
            "Size",
            "Uploaded By",
            "Upload Date",
            "Download",
        ];
        const rows = files.map((f, index) => {
            return [
                {
                    content: f.name
                },
                {
                    content: this.renderDropdown(f.fileCategory, index),
                    sortItem: (f.fileCategory),
                    type: 'render'
                },
                {
                    content: this.renderSize(f.size),
                    sortItem: Number(f.size),
                    type: 'render'
                },
                {
                    content: f.createUser
                },
                {
                    content: f.createDate
                },
                {
                    content: this.renderDownload(f),
                    type: 'render',
                },
            ];

        });

        return { headers, rows };
    }

    private formatDispatchTickets = () => {
        const tickets = this.state.well.dispatchTickets;
        const headers = [
            "Name",
            "Type",
            "Received By",
            "Received Date",
            "Download"
        ];
        const rows = tickets.map((t, index) => {
            return [
                {
                    content: 'DT' + t.ticketNumber
                },
               {
                   content: t.type === "Delivery" ? t.type : "Pickup"
               },
               {
                   content: t.receivedBy
               },
               {
                   content: t.receivedDate,
               },
               {
                    content: this.renderDispatchTicketDownload(t, index),
                    type: 'render',
               },  
            ];

        });

        return { headers, rows };
    } 

    private buttonNavigation = (event: any) => {
        const $target = event.target;

        if ($target.name === 'previousButton') {
            if (this.props.workflowHeaderItems[0].some((w: string) => w === 'Dispatches')) {
                this.props.history.push('/well/' + this.params.wellId + '/dispatches');
            } else {
                this.props.history.push('/well/' + this.params.wellId + '/contacts');
            }
        } else {
            this.props.history.push('/well/' + this.params.wellId + '/review');
        }
    }


    public render() {
        return (
            <div>
                <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
                <WorkflowHeader wellSetupComplete={this.state.well.wellSetupComplete} workflowHeaderItems={this.props.workflowHeaderItems} />
                <Row>
                    <Col>
                        <FormGroup>
                            <Label>Upload File</Label>
                            <Input
                                type="file"
                                name="file"
                                id="file"
                                multiple={true}
                                onChange={this.onFileChange}
                            />
                        </FormGroup>
                    </Col>
                    <Col>
                        <Button
                            color="primary"
                            onClick={this.onFileUpload}
                        >
                            Upload File
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <DataTable
                            list={this.formatWellFiles()}
                            onDelete={this.handleDeleteFile}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <DataTable
                            list={this.formatDispatchTickets()}
                        />
                    </Col>
                </Row>
                <ButtonRow>
                    <WellRevertCloseButton />
                    {<WellCloseButton />}
                    {this.WellsStore.canUpdateWell() && <EButton disabled={this.state.submitDisabled} color="primary" name="save" onClick={this.updateWellModel}>Save</EButton>}
                    <Button className="secondary" name="previousButton" onClick={this.buttonNavigation}>Previous</Button>
                    <Button className="secondary" name="nextButton" onClick={this.buttonNavigation}>Next</Button>
                    <WellFooter />
                </ButtonRow>

            </div>
        );
    }
}

export default withRouter(WellFiles);


// WEBPACK FOOTER //
// ./src/Components/Main/WellWorkflow/WellFiles/WellFiles.tsx